import React from 'react';

const FormButton = ({ label, onClick, type = 'button', disabled = false,className='' }) => {
  return (
    <input
      type={type}
      onClick={onClick}
      disabled={disabled}
      value={label}
      className={`px-4 py-2 bg-blue-500 text-white font-semibold ${className} rounded-lg shadow hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 transition ease-in-out duration-150 ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    />
  );
};

export default FormButton;
